import { render, staticRenderFns } from "./AnnotationRecordItem.vue.js?vue&type=template&id=fb6c9d70&scoped=true!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./AnnotationRecordItem.vue?vue&type=template&id=fb6c9d70&scoped=true"
import script from "./AnnotationRecordItem.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./AnnotationRecordItem.vue?vue&type=script&lang=js"
export * from "./AnnotationRecordItem.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./AnnotationRecordItem.vue?vue&type=script&lang=js"
import style0 from "./AnnotationRecordItem.vue.scss?vue&type=style&index=0&id=fb6c9d70&prod&scoped=true&lang=scss!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./AnnotationRecordItem.vue?vue&type=style&index=0&id=fb6c9d70&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb6c9d70",
  null
  
)

export default component.exports